<template lang="pug">
    .point-of-sale-error.full-height-error.not-valid(v-if="!enabled")
        Error(:message="null" :code="403")
    .point-of-sale(v-else)
        //- .loading.overlay(v-if="loading" v-loading="true")
        .grid(v-loading="loading")
            .left
                .head
                    //- a.logo(v-if="logo" href="#" @click.stop.prevent="toggleFullscreen")
                    //-     img(ref="logo" :src="logo")
                    //- a.logo.icon(v-else href="#" @click.stop.prevent="toggleFullscreen")
                    //-     i.fas.el-icon-fa-expand
                    a.logo.icon(href="#" @click.stop.prevent="toggleFullscreen")
                        span
                            i.fas.el-icon-fa-expand
                        //- svg(
                        //-     mlns="http://www.w3.org/2000/svg"
                        //-     fill="none"
                        //-     viewBox="0 0 24 24"
                        //-     stroke-width="1.5"
                        //-     stroke="currentColor"
                        //-     class="w-6 h-6"
                        //- )
                        //-     path(
                        //-         stroke-linecap="round"
                        //-         stroke-linejoin="round"
                        //-         d="M3 8.25V18a2.25 2.25 0 002.25 2.25h13.5A2.25 2.25 0 0021 18V8.25m-18 0V6a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 6v2.25m-18 0h18M5.25 6h.008v.008H5.25V6zM7.5 6h.008v.008H7.5V6zm2.25 0h.008v.008H9.75V6z"
                        //-     )
                    .searchbar
                        //- @blur="observeFocusChanges"
                        input(
                            ref="search"
                            type="text"
                            v-model="query"
                            onfocus="this.select()"
                            @change="find"
                        )
                        .icon
                            .spinner(v-if="searching")
                            svg.h-6.w-6(
                                v-else
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                stroke-width="2"
                            )
                                path(
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                )
                    a.refresh.icon(href="#" @click.stop.prevent="refresh")
                        //- span
                        //-     i.fas.el-icon-fa-sync
                        svg(
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="2.2"
                            stroke="currentColor"
                            class="w-6 h-6"
                        )
                            path(
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
                            )
                shopping-cart(
                    ref="shopping-cart"
                    @create-coupon="createCoupon"
                    @ask-for-refund="askForRefund"
                    @focus-search="focusSearchInput"
                    @blur-search="blurSearchInput"
                    @open-cash-book-for-remaining-amount="openCashBookForRemainingAmount"
                )
            .right
                .head
                    tabs(:items="tabs" :active-tab="activePosTab" @click="activateTab")
                        template(v-slot:put-aside:suffix)
                            .pill.danger(v-if="numberOfPurchasesOnHold") {{ numberOfPurchasesOnHold }}
                        template(v-slot:reserve:suffix)
                            .pill.danger(v-if="numberOfPendingArticleReservations") {{ numberOfPendingArticleReservations }}
                        template(v-slot:shipping:suffix)
                            .pill.primary(v-if="numberOfPendingArticleShippings") {{ numberOfPendingArticleShippings }}
                        //- Slot name MUST match the tab's `key` ('conversations'); Tabs.vue
                        //- renders `${item.key}:suffix`. It was still 'messages' from before
                        //- the tab was renamed, so the badge silently never rendered.
                        template(v-slot:conversations:suffix)
                            .pill.danger(v-if="messagesUnread") {{ messagesUnread }}
                .contains-contents(v-if="$route.name === 'point-of-sale'")
                    .body
                        .tab-content.scroll-box(v-dragscroll)
                            //- .under-construction
                            //-     i.el-icon-fa-snowplow.fas
                            //-     h4 {{ $t('Under Construction') }}
                            //-     p {{ $t('Come back another time') }}
                            section.row.customer-related-actions
                                .label
                                    i.el-icon-fa-user-friends.fas
                                    | {{ $t('Customer related actions') }}
                                .panel.buttons
                                    //- el-button(
                                    //-     type="info"
                                    //-     icon="el-icon-fa-times fas"
                                    //-     size="large"
                                    //-     disabled
                                    //- ) {{ $t('Cancel Purchase') }}
                                    take-back-drawer(
                                        ref="take-back-drawer"
                                        @focus-search="focusSearchInput"
                                        @blur-search="blurSearchInput"
                                    )
                                    coupon-drawer(
                                        ref="coupon-drawer"
                                        @focus-search="focusSearchInput"
                                        @blur-search="blurSearchInput"
                                    )
                                    //- el-button(
                                    //-     type="info"
                                    //-     icon="el-icon-fa-print fas"
                                    //-     size="large"
                                    //-     disabled
                                    //- ) {{ $t('Reprint Receipt') }}
                            section.row.location-related-actions
                                .label
                                    i.el-icon-fa-cash-register.fas
                                    | {{ $t('Location related actions') }}
                                .panel.buttons
                                    cash-book-drawer(ref="cash-book-drawer" @focus-search="focusSearchInput" @blur-search="blurSearchInput")
                                    update-stock-drawer(@focus-search="focusSearchInput" @blur-search="blurSearchInput")
                                    article-stock-drawer(@focus-search="focusSearchInput" @blur-search="blurSearchInput")
                            favorite-products.row.grow.favorite-products(
                                ref="favorite-products"
                                @add-article-to-cart="addDrawerArticleToCart"
                                @create-coupon="createCoupon"
                                @ask-for-refund="askForRefund"
                                @focus-search="focusSearchInput"
                                @blur-search="blurSearchInput"
                            )
                    //- .foot FOOT
                    //
                template(v-else)
                    router-view.contains-contents(:key="posRouteViewKey" @focus-search="focusSearchInput" @blur-search="blurSearchInput")
                    //- make sure the coupon drawer can always be opened
                    coupon-drawer.hide-button(
                        ref="coupon-drawer"
                        @focus-search="focusSearchInput"
                        @blur-search="blurSearchInput"
                    )

        refund-dialog(
            ref="refund-dialog"
            @create-coupon="createCoupon"
            @focus-search="focusSearchInput"
            @blur-search="blurSearchInput"
        )

        //- :wrapper-closable="false"
        el-drawer.found-products-drawer(
            :title="$t('Search results for \"{query}\"', { query })"
            :visible.sync="foundProductsDrawer.visibility"
            :modal="true"
            size="50%"
            @close="focusSearchInput"
            @closed="resetProductsDrawer"
        )
            .drawer-body(
                v-if="foundProductsDrawer.pagination.items"
                ref="foundProductsDrawerBody"
                @scroll="handleProductsDrawerScroll"
                v-dragscroll
            )
                table
                    tr.product-table-row
                        td.divider(colspan="5")
                            hr
                    product-preview(
                        v-for="product in foundProductsDrawer.pagination.items" :key="product.id"
                        :product="product"
                        @add-article-to-cart="addDrawerArticleToCart"
                        @create-coupon="createCoupon"
                        @ask-for-refund="askForRefund"
                    )
                .drawer-spinner-container(v-if="foundProductsDrawer.loading")
                    .spinner-background
                        .spinner
            //- .drawer-footer
            //-     el-button(
            //-         round
            //-         size="mini"
            //-         icon="el-icon-fa-times fas"
            //-         @click="closeModal"
            //-     ) {{ $t('Dismiss') }}
            //-     el-button(
            //-         round
            //-         size="mini"
            //-         :disabled="ui.form.loading || ui.form.saving"
            //-         :loading="ui.form.saving"
            //-         type="primary"
            //-         icon="el-icon-fa-check fas"
            //-         @click="saveArticle"
            //-     ) {{ $t('Save and close article') }}

        portal(to="header-center")
            .col.inline-selection
                .select(v-if="options.pointOfSale.items.length > 1")
                    //- .label {{ $t('Point Of Sale') }}
                    .dynamic-width-field
                        .occupy-width {{ activePointOfSale.name }}
                        el-select(
                            placeholder=""
                            v-model="activePointOfSale"
                            valueKey="id"
                            size="mini"
                            :loading="options.pointOfSale.loading"
                        )
                            el-option(v-for="pos in options.pointOfSale.items" :key="pos.id" :label="pos.name" :value="pos")
        //- portal(to="header-right")
        //-     .col.inline-selection
        //-         .select
        //-             .label {{ $t('Is Operated By') }}
        //-             .dynamic-width-field
        //-                 .occupy-width {{ cashier.name }}
        //-                 el-select(
        //-                     placeholder=""
        //-                     v-model="cashier"
        //-                     valueKey="id"
        //-                     size="mini"
        //-                 )
        //-                     el-option(v-for="cahsier in cashiers" :key="cahsier.id" :label="cahsier.name" :value="cahsier")
</template>

<i18n>
{
    "en": {
        "Search results for \"{query}\"": "Search results for \"{query}\""
    },
    "de": {
        "Article": "Artikel",
        "Price": "Einzelpreis",
        "Quantity": "Anzahl",
        "Total": "Gesamt",
        "Point Of Sale": "Kasse",
        "Is Operated By": "wird bedient von",
        "Reserve": "Reservieren",
        "Online": "Online",
        "Put Aside": "Zurückgelegt",
        "Stock": "Warenbestand",
        "Discount": "Rabatt",
        "Nothing Scanned": "Keine Ware erfasst",
        "Could not find anything": "Es konnte nichts gefunden werden",
        "Where the heck are the customers?": "Wo bleiben die Kunden?",
        "Shipping": "Versand",
        "Newsletter": "Newsletter",
        "Messages": "Nachrichten",
        "Conversations": "Konversationen",
        "Search results for \"{query}\"": "Suchergebnisse für die Suche nach \"{query}\"",
        "Article not found": "Artikel konnte nicht gefunden werden",
        "Cancel Purchase": "Kauf stornieren",
        "Reprint Receipt": "Belege drucken",
        "Customer related actions": "Kundenbezogene Aktionen",
        "Location related actions": "Standortbezogene Aktionen",
        "By": "Von",
        "At": "Am"
    }
}
</i18n>

<script>

import echo from '@/echo';

import ally from 'ally.js';
import printJS from 'print-js-updated';
import pinia from '@/pinia';
import { useAuthStore, useSetupStore, usePosSetupStore, usePosCartStore, useCommunicationStore } from '@/stores'
import { checkRestrictions } from '@/helpers';

import Tabs from '@/components/Tabs';
import Error from '@/components/Error';
import PropertyValue from '@/extensions/shop/views/Purchase/Form/Partials/PropertyValue'

import ShoppingCart from './Partials/ShoppingCart'
import ProductPreview from './Partials/ProductPreview'
import CashBookDrawer from './Partials/CashBookDrawer'
import TakeBackDrawer from './Partials/TakeBackDrawer'
import UpdateStockDrawer from './Partials/UpdateStockDrawer'
import CouponDrawer from './Partials/CouponDrawer'
import RefundDialog from './Partials/RefundDialog'
import ArticleStockDrawer from './Partials/ArticleStockDrawer'
import FavoriteProducts from './Partials/FavoriteProducts'

export default {
    name: 'PointOfSale',
    data() {
        return {
            query: '',
            searching: false,
            foundProductsDrawer: {
                visibility: false,
                loading: false,
                pagination: {
                    filters: {},
                    pageInfo: {
                        total: 0,
                        perPage: 12,
                        currentPage: 1,
                        lastPage: 0,
                    },
                    items: []
                }
            },
        }
    },
    components: {
        Tabs,
        Error,
        ShoppingCart,
        ProductPreview,
        PropertyValue,
        UpdateStockDrawer,
        CashBookDrawer,
        TakeBackDrawer,
        CouponDrawer,
        RefundDialog,
        ArticleStockDrawer,
        FavoriteProducts,
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true);
            if (reload) this.initialize('POS');
        },
        // Keep the POS Messages tab badge scoped to THIS POS and live.
        'activePointOfSale.id': {
            immediate: true,
            handler(id) {
                if (this.enabledExtensions.includes('communication')) this.conversationStore.fetchPosUnreadCount(id);
            }
        },
        'conversationStore.realtimeTick'() {
            if (this.enabledExtensions.includes('communication')) {
                this.conversationStore.fetchPosUnreadCount(_.get(this.activePointOfSale, 'id'));
            }
        },
        '$i18n.locale'(locale) {
            // console.log('fooooooooo')
        },
        autofocusSearchInput(focus) {
            if (focus) this.focusSearchInput()
        },
        // NOTE: gets handled in updateActivePointOfSale action
        // activePointOfSale(pos) {
        //     this.initialize();
        // }
    },
    computed: {
        activeCms() {
            return useSetupStore().activeCms
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions
        },
        setupStore() {
            return useSetupStore(pinia)
        },
        posSetupStore() {
            return usePosSetupStore()
        },
        posCartStore() {
            return usePosCartStore()
        },
        tabs() {
            const tabs = [
                {
                    key: 'point-of-sale',
                    name: this.$t('Point Of Sale'),
                    path: '/point-of-sale',
                    icon: {
                        name: 'cash-register',
                        group: 'fas'
                    }
                },
                {
                    key: 'put-aside',
                    name: this.$t('Put Aside'),
                    path: '/point-of-sale/put-aside',
                    icon: {
                        name: 'archive',
                        group: 'fas'
                    }
                },
                // {
                //     key: 'stock',
                //     name: this.$t('Stock'),
                //     path: '/point-of-sale/stock',
                //     icon: {
                //         name: 'dolly',
                //         group: 'fas'
                //     }
                // },
                {
                    key: 'reserve',
                    name: this.$t('Online'),
                    path: '/point-of-sale/reserve',
                    icon: {
                        name: 'cart-arrow-down',
                        group: 'fas'
                    }
                },
                {
                    key: 'shipping',
                    name: this.$t('Shipping'),
                    path: '/point-of-sale/shipping',
                    icon: {
                        name: 'truck',
                        group: 'fas'
                    }
                },
            ];

            // Add newsletter tab if newsletter extension is enabled
            if (this.enabledExtensions.includes('newsletter')) {
                tabs.push({
                    key: 'newsletter',
                    name: this.$t('Newsletter'),
                    path: '/point-of-sale/newsletter',
                    icon: {
                        name: 'envelope',
                        group: 'fas'
                    }
                });
            }

            // Add messages tab only when communication is enabled, the employee may
            // read messages, AND this POS has at least one of its own connections
            // (POS messaging never falls back to the CMS, so no connection = no tab).
            if (this.enabledExtensions.includes('communication')
                && checkRestrictions(['ex:comm', 'ex:comm:messages'])
                && this.activePointOfSale && this.activePointOfSale.has_communication_connection) {
                tabs.push({
                    key: 'conversations',
                    name: this.$t('Conversations'),
                    path: '/point-of-sale/conversations',
                    icon: {
                        name: 'comments',
                        group: 'far'
                    }
                });
            }

            return tabs;
        },
        // The conversations route carries a `:id` (/point-of-sale/conversations/:id) so the
        // open conversation survives reload / is deep-linkable. Collapse that id to the tab
        // base so the tab stays HIGHLIGHTED while a conversation is open...
        activePosTab() {
            return this.$route.path.indexOf('/point-of-sale/conversations') === 0
                ? '/point-of-sale/conversations'
                : this.$route.fullPath;
        },
        // ...and so switching/opening conversations doesn't remount the whole panel (the
        // router-view key stays stable across the id, like the global inbox).
        posRouteViewKey() {
            return this.$route.path.indexOf('/point-of-sale/conversations') === 0
                ? '/point-of-sale/conversations'
                : this.$route.path;
        },
        enabled() {
            return this.enabledExtensions.includes('shop:point-of-sale') && this.enabledExtensions.includes('shop');
        },
        logo() {
            return this.activeCms.logo
        },
        activePointOfSale: {
            get() {
                return this.activePOS
            },
            set(value) {
                this.updateActivePOS(value)
            }
        },
        // cashiers() {
        //     // TODO
        //     return [{
        //         id: 1,
        //         name: 'Karl Heinz',
        //     }]
        // },
        // cashier: {
        //     get() {
        //         return { id: 1 }
        //     },
        //     set() {
        //         // TODO
        //     }
        // },
        user() {
            return useAuthStore().user;
        },
        initialized() {
            return this.posSetupStore.initialized;
        },
        activePOS() {
            return this.posSetupStore.activePointOfSale;
        },
        loading() {
            return this.posSetupStore.loading;
        },
        options() {
            return this.posSetupStore.options;
        },
        numberOfPurchasesOnHold() {
            return this.posSetupStore.numberOfPurchasesOnHold;
        },
        numberOfPendingArticleReservations() {
            return this.posSetupStore.numberOfPendingArticleReservations;
        },
        numberOfPendingArticleShippings() {
            return this.posSetupStore.numberOfPendingArticleShippings;
        },
        conversationStore() {
            return useCommunicationStore();
        },
        // Realtime unread total (WS-driven) for the "Messages" POS tab badge —
        // scoped to THIS POS (strict isolation), not the CMS-wide total.
        messagesUnread() {
            return this.conversationStore.posUnreadCount;
        },
        autofocusSearchInput() {
            return this.posSetupStore.autofocusSearchInput;
        }
    },
    methods: {
        async find() {
            this.searching = true
            const article = await this.findArticle({ sku: this.query })
                // .then(article => {
                //     this.query = ''
                //     this.addArticleToCart({ article })
                //     this.saveCart()
                // })
                // .catch(err => {
                //     // this.$refs.search.focus()
                //     // this.$refs.search.select()

                //     this.query = ''

                //     this.$notify.error({
                //         title: this.$t('Article not found'),
                //         iconClass: 'fas el-icon-fa-times',
                //         position: 'bottom-left',
                //         customClass: 'dark',
                //         duration: 8000
                //     });

                //     console.error(err)
                // })
                // .finally(() => {
                //     this.searching = false
                // })
                .catch(err => console.error(err))

            if (article) {
                this.query = ''
                this.searching = false
                this.addArticleToCart({ article })
                this.saveCart()

                if (this.$refs['shopping-cart'] && this.$refs['shopping-cart'].$refs['body']) {
                    this.$refs['shopping-cart'].$refs['body'].scrollTop = 0
                }
            } else {
                this.loadProductsIntoDrawer()
            }
        },
        async loadProductsIntoDrawer(page = 1) {
            this.$set(this.foundProductsDrawer.pagination.pageInfo, 'currentPage', page)

            if (!this.foundProductsDrawer.pagination.filters) {
                this.$set(this.foundProductsDrawer.pagination, 'filters', {})
            }
            this.$set(this.foundProductsDrawer.pagination.filters, 'query', {
                key: 'query',
                like: this.query
            })
            this.$set(this.foundProductsDrawer.pagination.filters, 'shop', {
                key: 'shop',
                match: this.activeCms.shop.id
            })
            // this.$set(this.foundProductsDrawer.pagination.filters, 'status', {
            //     key: 'status',
            //     match: 'enabled'
            // })

            const paginatedProducts = await this.fetchProductsPaginated(this.foundProductsDrawer.pagination)
                .catch(err => {
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });

                    console.error(err)
                })

            this.searching = false
            if (paginatedProducts.items && paginatedProducts.items.length) {
                if (page > 1) {
                    this.foundProductsDrawer.pagination.items =
                        [...this.foundProductsDrawer.pagination.items, ...paginatedProducts.items]
                } else {
                    this.foundProductsDrawer.pagination = paginatedProducts;
                    this.foundProductsDrawer.visibility = true;
                    this.updateAutofocusSearchInput(false);

                    this.$refs.search.blur();
                }
                this.$nextTick(() => {
                    if (this.$refs.foundProductsDrawerBody) {
                        // this.$refs.foundProductsDrawerBody.style['scroll-behavior'] = 'smooth';
                        this.$refs.foundProductsDrawerBody.scrollTop = 0
                    }
                    this.loadMoreProductsIfNeeded(this.$refs.foundProductsDrawerBody)
                    // console.log(this.$refs.foundProductsDrawerBody)
                })
                this.foundProductsDrawer.loading = false;
            } else {
                this.query = ''
                this.$notify.error({
                    title: this.$t('Could not find anything'),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000
                });
            }
        },
        handleProductsDrawerScroll(event) {
            const { target } = event;
            this.loadMoreProductsIfNeeded(target)
        },
        loadMoreProductsIfNeeded(target) {
            const currentPage = this.foundProductsDrawer.pagination.pageInfo.currentPage;
            if (this.foundProductsDrawer.loading === false && this.foundProductsDrawer.pagination.pageInfo.lastPage > currentPage) {

                let loadMore = false;
                // const offset = window.innerHeight * 0.8;
                const offset = window.innerHeight;
                if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight - offset) loadMore = true;

                if (loadMore) {
                    this.foundProductsDrawer.loading = true;
                    this.loadProductsIntoDrawer(currentPage + 1)
                }
            }
        },
        addDrawerArticleToCart(article, selectedPropertyPivots) {
            this.addArticleToCart({ article, selectedPropertyPivots })
            this.saveCart();

            this.foundProductsDrawer.visibility = false;
            this.updateAutofocusSearchInput(true);
            if (this.$refs['shopping-cart'] && this.$refs['shopping-cart'].$refs['body']) {
                this.$refs['shopping-cart'].$refs['body'].scrollTop = 0
            }
        },
        createCoupon(amount) {
            if (this.$refs['coupon-drawer']) {
                this.$refs['coupon-drawer'].openCouponDrawer(amount)

                // awoid flickering
                setTimeout(() => {
                    this.foundProductsDrawer.visibility = false
                    setTimeout(() => {
                        this.updateAutofocusSearchInput(false)
                        this.blurSearchInput()
                    }, 400)
                }, 200)
            }
        },
        askForRefund(data) {
            if (this.$refs['refund-dialog']) {
                this.$refs['refund-dialog'].openRefundDialog(data)

                // awoid flickering
                setTimeout(() => {
                    this.foundProductsDrawer.visibility = false
                    setTimeout(() => {
                        this.updateAutofocusSearchInput(false)
                        this.blurSearchInput()
                    }, 400)
                }, 200)
            }
        },
        openCashBookForRemainingAmount(data) {
            if (this.$refs['cash-book-drawer']) {
                this.$refs['cash-book-drawer'].openCashBookDrawerWithPrefill(data)
            }
        },
        resetProductsDrawer() {
            this.query = '';
            this.foundProductsDrawer = {
                visibility: false,
                loading: false,
                pagination: {
                    filters: {},
                    pageInfo: {
                        total: 0,
                        perPage: 12,
                        currentPage: 1,
                        lastPage: 0,
                    },
                    items: []
                }
            }
            this.updateAutofocusSearchInput(true);
        },

        toggleFullscreen() {
            document.querySelector('body').classList.toggle('show-navigation')
            this.focusSearchInput()
        },
        refresh() {
            window.location.reload()
        },
        // debouncedObserveFocusChange: _.debounce(function(event) { // function scope is needed here
        //     this.observeFocusChanges(event)
        // }, 100),
        debouncedObserveFocusChange(event) { // function scope is needed here
            this.observeFocusChanges(event)
        },
        observeFocusChanges() {
            // Defer to a MACROTASK (setTimeout 0), not a $nextTick microtask: when
            // focus moves from field A to field B there is a window where the browser
            // has blurred A but not yet focused B, so document.activeElement is <body>.
            // A microtask check runs INSIDE that window, sees the non-focusable <body>,
            // and refocuses the POS search — hijacking the click before B ever gets
            // focus (which broke every input on the Messages tab). A macrotask runs
            // after the transition settles, so we see the real target.
            setTimeout(() => {
                const active = document.activeElement
                // Never fight a rich-text editor (the Messages composer is a
                // contenteditable div, which ally.is.focusable also rejects).
                if (active && (active.isContentEditable || (active.closest && active.closest('.ql-editor, [contenteditable="true"]')))) {
                    return
                }
                if (!ally.is.focusable(active) && this.autofocusSearchInput !== false) {
                    this.focusSearchInput()
                }
            }, 0)
        },
        focusSearchInput() {
            // this.updateAutofocusSearchInput(true);
            if (this.$refs.search) this.$refs.search.focus()
        },
        blurSearchInput() {
            // this.updateAutofocusSearchInput(false);
            if (this.$refs.search) this.$refs.search.blur()
        },
        addArticleToCart(payload) {
            return this.posCartStore.addItem(payload);
        },
        updateAutofocusSearchInput(value) {
            return this.posSetupStore.updateAutofocusSearchInput(value);
        },
        updateNumberOfPendingArticleReservations(value) {
            return this.posSetupStore.updateNumberOfPendingArticleReservations(value);
        },
        activateTab(item) {
            return this.setupStore.activateTab(item)
        },
        initialize(context) {
            return this.posSetupStore.initialize(context);
        },
        updateActivePOS(value) {
            return this.posSetupStore.updateActivePointOfSale(value);
        },
        findArticle(payload) {
            return this.posCartStore.findArticle(payload);
        },
        fetchProductsPaginated(payload) {
            return this.posCartStore.fetchProductsPaginated(payload);
        },
        saveCart() {
            return this.posCartStore.save();
        },
        saveMiscSettings(payload) {
            return this.setupStore.saveMiscSettings(payload);
        }
    },
    beforeRouteUpdate(to, from, next) {
        next()
        this.focusSearchInput()
    },
    mounted() {
        // TODO:
        // add event listeners on all focusable/input elements
        // on blur, focus the search input
        // also listen for blur event on search input
        // and focus it again if not another focusable/input element is focused

        if (this.$refs.search) {
            this.$refs.search.addEventListener('focusout', this.debouncedObserveFocusChange)
        }
        document.addEventListener('focusin', this.observeFocusChanges)
        document.addEventListener('click', this.observeFocusChanges)

        // Keep the "Messages" tab badge live over WebSocket (POS has no main sidebar).
        if (this.enabledExtensions.includes('communication') && checkRestrictions(['ex:comm', 'ex:comm:messages'])) {
            this.conversationStore.subscribeRealtime()
        }

        if (!this.initialized || !this.activePointOfSale.id) {
            this.initialize('POS')
                .then(() => {
                    setTimeout(this.focusSearchInput, 100)
                    // const id = this.activePointOfSale.id
                    // // listen to broadcasted pos events
                    // echo.client.private(`point-of-sale.${id}`)
                    //     .listen('.purchase-created', purchase => {
                    //         console.log('created', purchase)
                    //     })
                    //     .listen('.purchase-updated', purchase => {
                    //         console.log('updated', purchase)
                    //     })
                    //     .listen('.purchase-payed', purchase => {
                    //         console.log('payed', purchase)
                    //     })
                    //     .listen('.purchase-canceled', purchase => {
                    //         console.log('canceled', purchase)
                    //     })
                })
        } else {
            setTimeout(this.focusSearchInput, 100)
        }
    },
    // beforeDestroy() {
    //     // stop listening
    //     const id = this.activePointOfSale.id
    //     echo.client.private(`point-of-sale.${id}`)
    //         .stopListening('.purchase-created')
    //         .stopListening('.purchase-updated')
    //         .stopListening('.purchase-payed')
    //         .stopListening('.purchase-canceled')
    // }
    beforeDestroy() {
        if (this.$refs.search) {
            this.$refs.search.removeEventListener('focusout', this.debouncedObserveFocusChange)
        }
        document.removeEventListener('focusin', this.observeFocusChanges)
        document.removeEventListener('click', this.observeFocusChanges)

        // let stock = this.activePointOfSale.stocks.find((element) => element.key == "default");
        // if (stock) {
        //     echo.client.private(`stock.${stock.id}`)
        //         .stopListening('.articlestock-report-created')
        // }
    },
}
</script>

<style lang="sass" scoped>
#body
    .point-of-sale
        display: none
        .grid
            display: grid

#body.point-of-sale
    .point-of-sale
        display: block

.point-of-sale .grid
    grid-template-rows: auto
    grid-template-columns: repeat(2, minmax(0, 1fr))
    // gap: 1rem
    height: 100%
    .left, .right
        display: flex
        flex-direction: column
        .head, .foot
            padding: 1rem
        .head
            height: 80px
        .body
            position: relative
            flex-grow: 1
            /* overflow-x: hidden */
            /* overflow-y: auto */
            /* max-height: 100% */
            /* max-height: calc(100vh - 140px) */
            .scroll-box
                padding: 1rem
                position: absolute
                left: 0
                top: 0
                width: 100%
                height: 100%
                // height: calc(100% - 2px)
                overflow-x: hidden
                overflow-y: auto
    .left
        position: relative
        &:after
            content: ''
            position: absolute
            width: 2px
            right: -1px
            top: 1rem
            bottom: 1rem
            background: darken($color-skeleton, 10%)
        .head
            display: flex
            padding: 0
            align-items: center
            .logo,
            .refresh
                padding: 1rem
                // padding-right: 0
                &.icon
                    font-size: 2rem
                    color: darken($color-skeleton, 40%)
                    display: flex
                    justify-content: center
                    align-items: center
                    &:hover,
                    &:focus
                        color: $--shop-color-primary
                    svg
                        width: 36px
                    span
                        display: block
            .logo
                &.icon
                    padding-right: 0
                    svg
                        // transform: rotate(-90deg) scale(-1, 1)
                img
                    max-height: 32px
                    display: block
            .refresh
                &.icon
                    padding-left: 0
            .searchbar
                flex-grow: 1
                margin: 1rem
    .right
        .contains-contents
            display: contents
        .head
            display: flex
            flex-direction: colulmn
            align-items: flex-end
            padding-bottom: 0
            height: calc(80px - 1rem)
            .Tabs
                width: 100%
                border-bottom: 2px solid rgba(0,0,0, 0.1)
                margin-bottom: 1px
                overflow-x: auto
                overflow-y: hidden
                -webkit-overflow-scrolling: touch
                scrollbar-width: none
                &::-webkit-scrollbar
                    display: none
            &::v-deep
                .el-menu
                    flex-grow: 1
                    background: none
                    border-bottom: 0
                    margin-bottom: -2px
                    flex-wrap: nowrap
                    white-space: nowrap
                    .el-menu-item
                        font-size: 1.1rem
                        border-bottom-width: 2px
                        margin-bottom: 0
                        flex-shrink: 0
                        &.is-active
                            margin-bottom: -2px
                        span i
                            font-size: 0.8em
                        padding: 12px 14px
                        &.with-icon
                            padding-left: 10px
                        @media (max-width: 1400px)
                            font-size: 1rem
                            padding: 10px 12px
                            &.with-icon
                                padding-left: 8px
                        @media (max-width: 1200px)
                            font-size: 0.95rem
                            padding: 8px 10px
                            &.with-icon
                                padding-left: 6px
                        @media (max-width: 1000px)
                            font-size: 0.9rem
                            padding: 8px 8px
                            &.with-icon
                                padding-left: 5px
        .body
            display: flex
            .row + .row
                margin-top: 1rem

.searchbar
    position: relative
    .icon
        position: absolute
        width: 26px
        left: 10px
        top: 10px
        color: darken($color-skeleton, 20%)
    input
        width: 100%
        padding: 0.6rem 1rem
        padding-left: 40px
        border: 2px solid darken($color-skeleton, 10%)
        font-size: 1.2rem
        outline: none
        // &:hover
        //     &:not([disabled])
        //         box-shadow: 0 0 0px 0.125rem $--shop-color-primary
        //         border-color: rgba(0,0,0, 0.5)
        //         & + .icon
        //             color: rgba(0,0,0, 0.5)
        &:focus
            &:not([disabled])
                // border: 2px solid transparent
                // box-shadow: 0 0 0px 0.25rem rgba($--shop-color-primary, 0.25)
                & + .icon
                    color: $--shop-color-primary
                    svg
                        stroke-width: 3

.tab-content
    width: 100%
    display: flex
    flex-direction: column

.under-construction
    flex-grow: 1
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    padding: 4rem
    text-align: center
    i
        font-size: 4rem
        color: darken($color-skeleton, 20%)
    h4
        margin-top: 1rem
        margin-bottom: 0
        font-size: 2rem
        font-weight: 300
        color: darken($color-skeleton, 30%)

// .col.inline-selection.header-left
//     justify-content: flex-end !important
// .col.inline-selection.header-center
//     justify-content: center !important
// .col.inline-selection.header-right
//     justify-content: flex-start !important

.grid::v-deep .el-loading-mask
    background-color: rgba(242,244,248, 0.6)

.point-of-sale
    position: relative
    .loading.overlay
        position: absolute
        left: 0
        top: 0
        width: 100%
        height: 100%

.pill
    background-color: $--color-info
    display: inline-block
    padding: 2px 4px
    border-radius: 30px
    font-size: .8rem
    font-weight: bold
    color: white
    line-height: 0.9
    position: absolute
    top: 5px
    right: 5px
    &.danger
        background-color: $--color-danger
    &.primary
        background-color: $--color-primary

.drawer-body
    flex-grow: 1
    padding: 20px
    padding-top: 0
    max-height: calc(100vh - 66px)
    overflow: auto

    .product-preview
        & + .product-preview
            margin-top: 1rem

.found-products-drawer table
    width: 100%
    border-spacing: unset
    &::v-deep
        .dimmed
            color: $color-grey-text
        .divider hr
            opacity: 0.5

        .property-container
            display: flex
            gap: 4px
            ::v-deep .property-value
                padding: 4px 6px
                background: darken($color-skeleton, 10%)
                border-radius: 4px
                font-size: 0.85em
                label
                    font-size: 0.8em
                    display: block
                    &:after
                        content: ''
        .actions
            .delete-item
                margin-left: 2rem

        td
            // vertical-align: top
            padding: 2px 0.4rem
            &.info
                padding-left: 0
            &.min
                width: 1px
        tr.product-table-row >
            td, th
                &:first-child
                    padding-left: 0
                &:last-child
                    padding-right: 0

section.row::v-deep
    .label
        padding: 6px 12px
        margin-bottom: 0.5rem
        /* color: darken($color-grey-text, 20%) */
        /* color: $color-grey-text */
        i
            margin-right: 0.5rem
            color: $color-grey-text
    .panel.buttons
        // padding: 1rem
        // padding-right: 6px
        // /* background: rgba(220, 221, 223, 0.5) */
        // background: rgba(255,255,255, 0.4)
        // border-radius: 1rem
        // box-shadow: 0 2px 2px 0 rgba(0,0,0,0.04), 0 3px 1px -2px rgba(0,0,0,0.02), 0 1px 5px 0 rgba(0,0,0,0.1)
        display: flex
        flex-wrap: wrap
        gap: 0.5rem
        .el-button
            margin: 0
    & + section.row
        margin-top: 2rem !important

.searchbar .icon .spinner
    width: 26px
    height: 26px

.drawer-container
    display: contents
    &.hide-button::v-deep
        button
            display: none
</style>
